export const baseUrl = "https://dqflex-api.fly.dev";
